// extracted by mini-css-extract-plugin
export default {"nav_bar":"Navigation_nav_bar__UqGXq","nav_li":"Navigation_nav_li__9LwGe","logo":"Navigation_logo__u8znu"};